<template>
    <AboutProgram v-if="openModal" @closeModal="openModal = false" :isCourse="true" :item="selectedItem" @buyNewItem="openExtend = true"/>
    <extend v-if="openExtend"  @closeModal="openExtend = false" :props-item="selectedItem" :is-course="true"/>
    <PlatformLayout layout-class="schools" title="Языковая школа">
            <div class="schools__right__top">
                <div class="schools__right__top__tabs">
                    <div class="schools__right__top__tabs__in" v-for="(tab, index) in tabs" :key="tab"
                        :class="{ customTab: selectedTab == index }" @click="newTab(index)">
                        {{ tab.name }}
                    </div>
                </div>
            </div>
            <div class="line"></div>
            <div v-if="loading" class="schools-sk" aria-busy="true" aria-label="Загрузка данных школы">
                <div v-for="n in 2" :key="'sale-' + n" class="sk sk--sale" />
                <div v-for="n in 5" :key="'block-' + n" class="sk sk--block" />
            </div>
            <template v-else>
            <div class="schools__right__block" v-if="selectedTab == 0">
                <div class="schools__right__block__sale saleCard" v-for="item in sales" :key="item" :style="{ backgroundImage: `url('${item?.image}')` }">
                    <div class="schools__right__block__sale__top">
                        <p class="schools__right__block__sale__top__title">{{ item.name }}</p>
                        <p class="schools__right__block__sale__top__text">{{ item.description }}</p>
                    </div>
                    <a class="redButton" :href="item.link" target="_blank">Записаться</a>
                </div>
                <div class="offer customBlock">
                    <div class="customTitle">
                        <p>Описание и стоимость услуг</p>
                        <div class="line"></div>
                    </div>
                    <div class="offer__block">
                        <img src="@/assets/icons/selectRed.svg" class="arrowLeft1" style="rotate: 180deg;"/>
                        <swiper 
                        class="offer__block__swiper"
                        :navigation="{
                            nextEl: '.arrowRight1',
                            prevEl: '.arrowLeft1'}"
                        :breakpoints="{
                            0: {slidesPerView: 3, spaceBetween: 15},
                            640: { slidesPerView: 4, spaceBetween: 30 },
                        }"
                            >
                            <swiper-slide v-for="item in offers" :key="item" class="offer__block__swiper__slide">
                                <a :href="item.file" target="_blank"><img :src="item.image"/></a>
                                <a :href="item.file" target="_blank"><p class="offer__block__swiper__slide__name">{{item.title}}</p></a>
                            </swiper-slide>
                        </swiper>
                        <img src="@/assets/icons/selectRed.svg" class="arrowRight1"/>
                    </div>
                </div>
                <div class="indiv customBlock">
                    <div class="customTitle">
                        <p>Индивидуальные курсы general english</p>
                        <div class="line"></div>
                    </div>
                    <div class="indiv__block">
                        <div class="indiv__block__in" v-for="item in individual" :key="item.id">
                            <div class="indiv__block__in__left">
                                <p class="indiv__block__in__left__name">{{ item.title }}</p>
                                <p class="indiv__block__in__left__time">{{ item.price }}</p>
                            </div>
                            <button  @click="newItemId(item)">Купить</button>
                        </div>
                    </div>
                </div>
                <div class="indiv customBlock">
                    <div class="customTitle">
                        <p>Групповые курсы general english</p>
                        <div class="line"></div>
                    </div>
                    <div class="indiv__block">
                        <div class="indiv__block__in" v-for="item in group" :key="item">
                            <div class="indiv__block__in__left">
                                <p class="indiv__block__in__left__name">{{ item.title }}</p>
                                <p class="indiv__block__in__left__time">{{ item.price }}</p>
                            </div>
                            <button  @click="newItemId(item)">Купить</button>
                        </div>
                    </div>
                </div>
                <div class="indiv customBlock">
                    <div class="customTitle">
                        <p>платные онлайн курсы</p>
                        <div class="line"></div>
                    </div>
                    <div class="indiv__block">
                        <div class="indiv__block__in" v-for="item in paidCources" :key="item.id">
                            <div class="indiv__block__in__left">
                                <p class="indiv__block__in__left__name">{{ item.title }}</p>
                                <p class="indiv__block__in__left__time">{{ item.price }}</p>
                            </div>
                            <button  @click="newItemId(item)">Купить</button>
                        </div>
                    </div>
                </div>
                <div class="online customBlock parent">
                    <div class="customTitle">
                        <p>ОНЛАЙН бесплатные материалы</p>
                        <div class="line"></div>
                    </div>
                    <div class="online__block">
                        <div class="online__block__in" v-for="item in online" :key="item">
                            <div class="online__block__in__box1">
                                <div class="online__block__in__box1__color" :class="{customColor: item.status == 0}"></div>
                            </div>
                            <div class="online__block__in__name" :class="{customName: item.status == 0}">{{ item.title }}</div>
                            <div class="greenLine" v-if="item.status == 1"></div>
                            <div class="greyLine" v-if="item.status == 0"></div>
                            <a :href="item.link" v-if="item.status == 1" target="_blank">Доступен</a>
                            <a v-else style="border: 1px solid #8e8e8e; color: #8e8e8e;">Недоступен</a>
                        </div>
                    </div>
                    <div 
                        class="parent__backdrop" 
                        v-if="$store.state.role == 'guest'"
                        @click="toggleBlock(true)"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="#fff"><path d="M753-249q27.92 0 47.46-19.56t19.54-47.5Q820-344 800.46-363q-19.54-19-47.46-19-27.5 0-46.75 19.35-19.25 19.36-19.25 47 0 27.65 19.25 47.15T753-249Zm-.21 133Q786-116 815-131.5t47-42.5q-26-14-53-22.5t-56-8.5q-29 0-56 8.5T644-174q18 27 46.79 42.5 28.78 15.5 62 15.5ZM350-634h260v-93q0-57-37.5-95T480-860q-55 0-92.5 38T350-727v93ZM557-80H220q-23 0-41.5-18.5T160-140v-434q0-23 18.5-41.5T220-634h70v-93q0-81 55-137t135-56q80 0 135 56t55 137v93h70q23 0 41.5 18.5T800-574v87q-13-3-27-4t-33-1v-82H220v434h301q7 17 15 30.5T557-80Zm196 34q-79 0-136-57t-57-136q0-79 57-136t136-57q79 0 136 57t57 136q0 79-57 136T753-46ZM220-574v434-434Z"/></svg>
                    </div>
                </div>
                <div class="offer customBlock parent">
                    <div class="customTitle">
                        <p>Книги и гайды</p>
                        <div class="line"></div>
                    </div>
                    <div class="offer__block">
                        <img src="@/assets/icons/selectRed.svg" class="arrowLeft2" style="rotate: 180deg;"/>
                        <swiper 
                        class="offer__block__swiper"
                        :navigation="{
                            nextEl: '.arrowRight2',
                            prevEl: '.arrowLeft2'}"
                        :breakpoints="{
                            0: {slidesPerView: 3, spaceBetween: 15},
                            640: { slidesPerView: 4, spaceBetween: 30 },
                        }">
                            <swiper-slide v-for="item in booksForLang" :key="item" class="offer__block__swiper__slide">
                                <a :href="item.link" target="_blank"><img :src="item.image"/></a>
                                <a :href="item.link" target="_blank" class="offer__block__swiper__slide__name">{{ item.title }}</a>
                            </swiper-slide>
                        </swiper>
                        <img src="@/assets/icons/selectRed.svg" class="arrowRight2"/>
                    </div>
                    <div 
                      class="parent__backdrop" 
                      v-if="$store.state.role == 'guest'"
                      @click="toggleBlock(true)"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="#fff"><path d="M753-249q27.92 0 47.46-19.56t19.54-47.5Q820-344 800.46-363q-19.54-19-47.46-19-27.5 0-46.75 19.35-19.25 19.36-19.25 47 0 27.65 19.25 47.15T753-249Zm-.21 133Q786-116 815-131.5t47-42.5q-26-14-53-22.5t-56-8.5q-29 0-56 8.5T644-174q18 27 46.79 42.5 28.78 15.5 62 15.5ZM350-634h260v-93q0-57-37.5-95T480-860q-55 0-92.5 38T350-727v93ZM557-80H220q-23 0-41.5-18.5T160-140v-434q0-23 18.5-41.5T220-634h70v-93q0-81 55-137t135-56q80 0 135 56t55 137v93h70q23 0 41.5 18.5T800-574v87q-13-3-27-4t-33-1v-82H220v434h301q7 17 15 30.5T557-80Zm196 34q-79 0-136-57t-57-136q0-79 57-136t136-57q79 0 136 57t57 136q0 79-57 136T753-46ZM220-574v434-434Z"/></svg>
                    </div>
                </div>
                <div class="offer customBlock">
                    <div class="customTitle">
                        <p>НАШИ УЧИТЕЛЯ</p>
                        <div class="line"></div>
                    </div>
                    <div class="offer__block">
                        <img src="@/assets/icons/selectRed.svg" class="arrowLeft3" style="rotate: 180deg;"/>
                        <swiper 
                        class="offer__block__swiper"
                        :navigation="{
                            nextEl: '.arrowRight3',
                            prevEl: '.arrowLeft3'}"
                        :breakpoints="{
                            0: {slidesPerView: 3, spaceBetween: 15},
                            640: { slidesPerView: 4, spaceBetween: 30 },
                        }">
                            <swiper-slide v-for="item in teachers" :key="item" class="offer__block__swiper__slide">
                                <a :href="item.file" v-if="item.file" target="_blank"><img :src="item.image"/></a>
                                <a :href="item.link" v-if="item.link" target="_blank"><img :src="item.image"/></a>
                                <a :href="item.file" target="_blank" v-if="item.file"><p class="offer__block__swiper__slide__name">{{item.surname}} {{item.name}}</p></a>
                                <a :href="item.link"  target="_blank" v-if="item.link"><p class="offer__block__swiper__slide__name">{{item.surname}} {{item.name}}</p></a>
                            </swiper-slide>
                        </swiper>
                        <img src="@/assets/icons/selectRed.svg"  class="arrowRight3"/>
                    </div>
                </div>
                <div class="contact1 customBlock">
                    <div class="customTitle">
                        <p>КОНТАКТЫ И ПОМОЩЬ</p>
                        <div class="line"></div>
                    </div>
                    <div class="contact1__block">
                        <a :href="item.link" class="contact1__block__in" v-for="item in contacts" :key="item" target="_blank">
                            <img :src="item.icon"/>
                            <p>{{ item.title}}</p>
                        </a>
                    </div>
                </div>
            </div>
            <div class="schools__right__block" v-if="selectedTab == 1">
                <div class="cert saleCard" v-for="item in sales1" :key="item" :style="{ backgroundImage: `url('${item?.image}')` }">
                    <img src="@/assets/icons/british.jpg" class="cert__icon"/>
                    <p class="cert__title">
                        {{ item.name }}
                    </p>
                    <a class="redButton" :href="item?.file" target="_blank" v-if="item.file">Показать сертификат</a>
                    <a class="redButton" :href="item?.link" target="_blank" v-else>Показать сертификат</a>
                </div>
                <div class="test customBlock parent">
                    <div class="customTitle">
                        <p>ТЕСТЫ</p>
                        <div class="line"></div>
                    </div>
                    <div class="offer__block">
                        <img src="@/assets/icons/selectRed.svg" class="arrowLeft5" style="rotate: 180deg;"/>
                        <swiper 
                        class="offer__block__swiper"
                        :navigation="{
                            nextEl: '.arrowRight5',
                            prevEl: '.arrowLeft5'}"
                        :breakpoints="{
                            0: {slidesPerView: 3, spaceBetween: 15},
                            640: { slidesPerView: 4, spaceBetween: 30 },
                        }">
                            <swiper-slide v-for="item in testWidget" :key="item" class="offer__block__swiper__slide">
                                <a :href="item.file" target="_blank"><img src="@/assets/icons/testIcon.png" class="testImg"/></a>
                                <a :href="item.file" target="_blank" class="offer__block__swiper__slide__name">{{item.name}}</a>
                            </swiper-slide>
                        </swiper>
                        <img src="@/assets/icons/selectRed.svg" class="arrowRight5"/>
                    </div>
                    <div 
                        class="parent__backdrop" 
                        v-if="$store.state.role == 'guest'"
                        @click="toggleBlock(true)"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="#fff"><path d="M753-249q27.92 0 47.46-19.56t19.54-47.5Q820-344 800.46-363q-19.54-19-47.46-19-27.5 0-46.75 19.35-19.25 19.36-19.25 47 0 27.65 19.25 47.15T753-249Zm-.21 133Q786-116 815-131.5t47-42.5q-26-14-53-22.5t-56-8.5q-29 0-56 8.5T644-174q18 27 46.79 42.5 28.78 15.5 62 15.5ZM350-634h260v-93q0-57-37.5-95T480-860q-55 0-92.5 38T350-727v93ZM557-80H220q-23 0-41.5-18.5T160-140v-434q0-23 18.5-41.5T220-634h70v-93q0-81 55-137t135-56q80 0 135 56t55 137v93h70q23 0 41.5 18.5T800-574v87q-13-3-27-4t-33-1v-82H220v434h301q7 17 15 30.5T557-80Zm196 34q-79 0-136-57t-57-136q0-79 57-136t136-57q79 0 136 57t57 136q0 79-57 136T753-46ZM220-574v434-434Z"/></svg>
                    </div>
                    <!-- <div class="test__block">
                        <div class="test__block__in" v-for="item in testWidget" :key="item">
                            <img src="@/assets/icons/testIcon.png"/>
                            <a :href="item.file" target="_blank"><p class="test__block__in__name">{{ item.name }}</p></a>
                        </div>
                    </div> -->
                </div>
                <div class="online customBlock parent">
                    <div class="customTitle">
                        <p>ОНЛАЙН КУРСЫ</p>
                        <div class="line"></div>
                    </div>
                    <div class="online__block">
                        <div class="online__block__in" v-for="item in onlineTest" :key="item">
                            <div class="online__block__in__box1">
                                <div class="online__block__in__box1__color" :class="{customColor: item.status == 0}"></div>
                            </div>
                            <div class="online__block__in__name" :class="{customName: item.status == 0}">{{ item.title }}</div>
                            <div class="greenLine" v-if="item.status == 1"></div>
                            <div class="greyLine" v-if="item.status == 0"></div>
                            <a :href="item.link" v-if="item.status == 1" target="_blank">Доступен</a>
                            <a v-else style="border: 1px solid #8e8e8e; color: #8e8e8e;">Недоступен</a>
                        </div>
                    </div>
                    <div 
                        class="parent__backdrop" 
                        v-if="$store.state.role == 'guest'"
                        @click="toggleBlock(true)"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="#fff"><path d="M753-249q27.92 0 47.46-19.56t19.54-47.5Q820-344 800.46-363q-19.54-19-47.46-19-27.5 0-46.75 19.35-19.25 19.36-19.25 47 0 27.65 19.25 47.15T753-249Zm-.21 133Q786-116 815-131.5t47-42.5q-26-14-53-22.5t-56-8.5q-29 0-56 8.5T644-174q18 27 46.79 42.5 28.78 15.5 62 15.5ZM350-634h260v-93q0-57-37.5-95T480-860q-55 0-92.5 38T350-727v93ZM557-80H220q-23 0-41.5-18.5T160-140v-434q0-23 18.5-41.5T220-634h70v-93q0-81 55-137t135-56q80 0 135 56t55 137v93h70q23 0 41.5 18.5T800-574v87q-13-3-27-4t-33-1v-82H220v434h301q7 17 15 30.5T557-80Zm196 34q-79 0-136-57t-57-136q0-79 57-136t136-57q79 0 136 57t57 136q0 79-57 136T753-46ZM220-574v434-434Z"/></svg>
                    </div>
                </div>
                <div class="offer customBlock parent">
                    <div class="customTitle">
                        <p>Книги и гайды</p>
                        <div class="line"></div>
                    </div>
                    <div class="offer__block">
                        <img src="@/assets/icons/selectRed.svg" class="arrowLeft4" style="rotate: 180deg;"/>
                        <swiper 
                        class="offer__block__swiper"
                        :navigation="{
                            nextEl: '.arrowRight4',
                            prevEl: '.arrowLeft4'}"
                        :breakpoints="{
                            0: {slidesPerView: 3, spaceBetween: 15},
                            640: { slidesPerView: 4, spaceBetween: 30 },
                        }">
                            <swiper-slide v-for="item in booksForTest" :key="item" class="offer__block__swiper__slide">
                                <a :href="item.link" target="_blank"><img :src="item.image"/></a>
                                <a :href="item.link" target="_blank" class="offer__block__swiper__slide__name">{{item.title}}</a>
                            </swiper-slide>
                        </swiper>
                        <img src="@/assets/icons/selectRed.svg" class="arrowRight4"/>
                    </div>
                    <div 
                      class="parent__backdrop" 
                      v-if="$store.state.role == 'guest'"
                      @click="toggleBlock(true)"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="#fff"><path d="M753-249q27.92 0 47.46-19.56t19.54-47.5Q820-344 800.46-363q-19.54-19-47.46-19-27.5 0-46.75 19.35-19.25 19.36-19.25 47 0 27.65 19.25 47.15T753-249Zm-.21 133Q786-116 815-131.5t47-42.5q-26-14-53-22.5t-56-8.5q-29 0-56 8.5T644-174q18 27 46.79 42.5 28.78 15.5 62 15.5ZM350-634h260v-93q0-57-37.5-95T480-860q-55 0-92.5 38T350-727v93ZM557-80H220q-23 0-41.5-18.5T160-140v-434q0-23 18.5-41.5T220-634h70v-93q0-81 55-137t135-56q80 0 135 56t55 137v93h70q23 0 41.5 18.5T800-574v87q-13-3-27-4t-33-1v-82H220v434h301q7 17 15 30.5T557-80Zm196 34q-79 0-136-57t-57-136q0-79 57-136t136-57q79 0 136 57t57 136q0 79-57 136T753-46ZM220-574v434-434Z"/></svg>
                    </div>
                </div>
                <div class="indiv customBlock">
                    <div class="customTitle">
                        <p>ПОДГОТОВКА К ТЕСТАМ</p>
                        <div class="line"></div>
                    </div>
                    <div class="indiv__block">
                        <div class="indiv__block__in" v-for="item in tests" :key="item">
                            <div class="indiv__block__in__left">
                                <p class="indiv__block__in__left__name">{{ item?.title }}</p>
                                <p class="indiv__block__in__left__time">{{ item.price }}</p>
                            </div>
                            <button @click="newItemId(item)">Купить</button>
                        </div>
                    </div>
                </div>
            </div>
            </template>
    </PlatformLayout>
</template>
<script>
import PlatformLayout from '@/components/platform/PlatformLayout.vue';
import extend from '@/components/newPlatform/extend.vue';
import "swiper/css/scrollbar";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper";
import AboutProgram from '@/components/newPlatform/aboutProgram.vue';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import axios from "axios";
import { mapActions } from 'vuex';
export default {
    components: {
        PlatformLayout,
        Swiper,
        SwiperSlide,
        AboutProgram,
        extend,
    },
    data() {
        return {
            loading: true,
            selectedTab: 0,
            openModal: false,
            openExtend: false,
            courses: false,
            booksForLang: false,
            booksForTest: false,
            teachers: false,
            contacts: false,
            testWidget: false,
            selectedItem: '',
            offers: false,
            onlineTest: [
            ],
            online: [],
            tests: [],
            group: [],
            paidCources: [],
            sales: [
            ],
            sales1: [],
            individual: [
            ],
            tabs: [
                {
                    name: 'Языковая школа'
                },
                {
                    name: 'Тестовая школа'
                },
            ],
        }
    },
    methods:{
        ...mapActions(['toggleBlock']),
        newTab(index) {
            this.selectedTab = index,
            this.$router.push({ query: { tab: index } });
        },
        newItemId(item){
            this.selectedItem = item;
            this.openModal = true;
        },
        async getPage() {
          try {
            const [
              coursesRes,
              booksRes,
              teachersRes,
              contactsRes,
              quizzesRes,
              widgetsRes,
              certificationsRes,
              offersRes
            ] = await Promise.all([
              axios.get(`/platform/courses`).catch(() => ({ data: { data: [] } })),
              axios.get(`/platform/books`).catch(() => ({ data: { books: [] } })),
              axios.get(`/platform/teachers`).catch(() => ({ data: { teachers: [] } })),
              axios.get(`/platform/contacts`).catch(() => ({ data: { data: [] } })),
              axios.get(`/platform/quizzes`).catch(() => ({ data: { data: [] } })),
              axios.get(`/V1/page/widgets`).catch(() => ({ data: [] })),
              axios.get(`/V1/page/certifications`).catch(() => ({ data: [] })),
              axios.get(`/V1/offers`).catch(() => ({ data: { offers: [] } })),
            ]);

            // Courses
            this.courses = coursesRes.data.data;
            this.individual = this.courses.filter(item => item.type === 0);
            this.online = this.courses.filter(item => item.type === 1);
            this.group = this.courses.filter(item => item.type === 2);
            this.tests = this.courses.filter(item => item.type === 3);
            this.onlineTest = this.courses.filter(item => item.type === 4);
            this.paidCources = this.courses.filter(item => item.type === 5);

            // Books
            this.booksForLang = booksRes.data.books.filter(item => item.cat_id == 2);
            this.booksForTest = booksRes.data.books.filter(item => item.cat_id == 1);

            // Teachers
            this.teachers = teachersRes.data.teachers;

            // Contacts
            this.contacts = contactsRes.data.data.filter(item => item.type_id == 4);

            // Quizzes
            this.testWidget = quizzesRes.data.data;

            // Widgets
            this.offers = widgetsRes.data;

            // Certifications
            this.sales1 = certificationsRes.data;

            // Offers
            this.sales = offersRes.data.offers;

          } catch (err) {
            console.error("Ошибка загрузки данных:", err);
          } finally {
            this.loading = false;
          }
        }
    },
    async created() {
        this.getPage();
    },
    mounted() {
        const tabFromQuery = this.$route.query.tab;
        if (tabFromQuery) {
            this.selectedTab = Number(tabFromQuery);
        }
    },
}
</script>
<style lang="scss" scoped>
.customButton{
    border: 1px solid  #000000 !important;
    color: #000000 !important;
}
.testImg{
    object-fit: contain !important;
}
a{
    text-decoration: none;
    color: inherit;
    transition: all 0.5s ease;  
    &:hover{
        color: rgb(255, 0, 0);
    }
}
.customColor{
    background-color: inherit !important;
}
.customText{
    color: #000000 !important;
}
.customName{
    color: #8e8e8e !important;
}
.customLine{
    border-top: 1px solid  #000000 !important;
}
.customBlock{
    display: flex;
    flex-direction: column;
    gap: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
    padding: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px)min(max(18px, calc(1.125rem + ((1vw - 7.68px) * 1.0417))), 30px);
    background-color: white;
    width: 49%;
    p, a{
        font-size: 13px!important;
    }
    border-radius: 10px;
    overflow: auto;
    @media(max-width:768px){
        padding: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px);
        gap: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px);
        width: 100%;
    }
}
.indiv {
    &__block {
        display: flex;
        flex-direction: column;
        gap: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px);
        max-height: 100px;
        overflow-y: auto;
        &__in {
            display: flex;
            justify-content: space-between;
            align-items: center;
            &__left {
                display: flex;
                align-items: center;
                gap: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px);
                &__name {
                    font-weight: 700;
                    display: -webkit-box;
                    -webkit-line-clamp: 3; /* Limiting the text to 3 lines */
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
            button {
                width: 20%;
                border: 1px solid #FD2D2A;
                background-color: inherit;
                color: #FD2D2A;
                border-radius: 5px;
                font-weight: 700;
            }
        }
    }
    @media(max-width:768px){
        &__block{
            font-size: min(max(9px, calc(0.5625rem + ((1vw - 7.68px) * 0.434))), 14px);
        }
    }
}
.online{
    &__block{
        display: flex;
        flex-direction: column;
        gap: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
        &__in{
            display: flex;
            align-items: center;
            gap: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
            justify-content: space-between;
            &__box1{
                width: 5% !important;
                border-radius: 2px;
                aspect-ratio: 1;
                display: flex;
                justify-content: center;
                align-items: center;
                border: 1px solid #0000001A;
                &__color{
                border-radius: 2px;
                    width: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
                    height: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
                    background-color: #00D928;
                }
            }
            &__name{
                color: #00D928;
            }
            a{
                width: 20%;
                border: none;
                text-align: center;
                background-color: inherit;
                border: 1px solid #00DA0F;
                color: #00DA0F;
                border-radius: 5px;
            }
        }
    }
    @media(max-width:768px){
        &__block{
            gap: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px);
            font-size: min(max(9px, calc(0.5625rem + ((1vw - 7.68px) * 0.434))), 14px);
            &__in{
                gap: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px);
                &__box1{
                    &__color1{
                        width: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px);
                        height: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px);
                    }
                }
                button{
                    width: 30%;
                    font-size: min(max(9px, calc(0.5625rem + ((1vw - 7.68px) * 0.434))), 14px);
                }
            }
        }
    }
}
.greenLine{
    border-top: 1px solid #00DA0F;
    flex-grow: 1;
}
.greyLine{
    border-top: 1px solid #8e8e8e;
    flex-grow: 1;
}
.arrowLeft1,.arrowLeft2,.arrowLeft3,.arrowLeft4{
    position: absolute;
    width: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
    height: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
    bottom: 50%;
    left: 0%;
}
.arrowRight1,.arrowRight2,.arrowRight3,.arrowRight4{
    position: absolute;
    width: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
    height: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
    bottom: 50%;
    right: 0%;
}
.offer{
    &__block{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        &__swiper{
            width: 90%;
            &__slide{
                display: flex;
                flex-direction: column;
                gap: 10px;
                align-items: center;
                text-align: center;
                &__name {
                    font-weight: 700;
                    display: -webkit-box;
                    -webkit-line-clamp: 3; /* Limiting the text to 3 lines */
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                img{
                    width: 100%;
                    aspect-ratio: 0.8;
                    object-fit: cover;
                    border-radius: 10px;
                }
            }
        }
    }
    @media(max-width:768px){
        &__block{
            &__swiper{
                width: 85%;
            }
        }
    }
}
.line {
    width: 100%;
    border-top: 1px solid #0000001A;
}
.customTitle {
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;
    text-transform: uppercase;
    @media(max-width:768px){
        font-size: min(max(9px, calc(0.5625rem + ((1vw - 7.68px) * 0.434))), 14px);
    }
}
.customTab {
    color: #000000 !important;
}
.saleCard{
    width: 49%;
    border-radius: 10px;
    height: min(max(160px, calc(10rem + ((1vw - 7.68px) * 12.1528))), 300px);
    background-size: cover;
    background-position: center;
    color: white;
    padding: min(max(18px, calc(1.125rem + ((1vw - 7.68px) * 1.0417))), 30px);
    display: flex;
    flex-direction: column;
    position: relative;
    &::before{
        content: '';
        border-radius: 10px;
        // background: linear-gradient(180deg, rgba(0, 0, 0, 0.54) 0%, rgba(0, 0, 0, 0) 50.07%);
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        backdrop-filter: blur(1px);
        background: rgba(255, 255, 255, 0.1);
        z-index: 1;
    }
    @media(max-width:768px){
        width: 100%;
        aspect-ratio: 2.25;
        padding: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px);
    }
}
.schools {
    display: flex;
    justify-content: space-between;
    background: linear-gradient(180deg, #11415D 0px, #2488C3 500px);
    padding-top: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
    min-height: 100vh;
    &__left {
        width: 20%;
    }
    &__right {
        width: 80%;
        background-color: #F5F7FB;
        padding: 60px 80px;
        border-top-left-radius: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
        display: flex;
        flex-direction: column;
        gap: 40px;
        &__top {
            display: flex;
            justify-content: space-between;
            align-items: center;

            &__tabs {
                width: 70%;
                font-weight: 600;
                font-size: min(max(20px, calc(1.25rem + ((1vw - 7.68px) * 1.3889))), 36px);;
                color: #00000026;
                display: flex;
                gap: 40px;
                white-space: nowrap;
                overflow: hidden;
                -webkit-overflow-scrolling: touch;
                &__in {
                    cursor: pointer
                }
            }

            &__right {
                width: 25%;
            }
        }
        &__block {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            align-items: stretch;
            gap: 2%;
            row-gap: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
            &__sale {
                justify-content: space-between;
                &__top {
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                    &__title {
                        font-size: min(max(20px, calc(1.25rem + ((1vw - 7.68px) * 1.3889))), 36px);;
                        font-weight: 700;
                        z-index: 2;
                    }
                    &__text {
                        font-size: min(max(16px, calc(1rem + ((1vw - 7.68px) * 0.6944))), 24px);
                        z-index: 2;
                    }
                }
            }
        }
    }
    @media(max-width:768px){
        padding-top: 0px;
        &__left{
            display: none;
        }
        &__right{
            width: 100%;
            padding: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px)min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
            gap: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
            border-radius: 0px;
            &__top{
                &__tabs{
                    width: 100%;
                    font-size: 21px;
                }
                &__right{
                    display: none;
                }
            }
            &__block{
                row-gap: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px);
                &__sale{
                    &__top{
                        &__title{
                            font-size: min(max(16px, calc(1rem + ((1vw - 7.68px) * 0.6944))), 24px);
                        }
                        &__text{
                            font-size: 16px;
                        }
                    }
                }
            }
        }
    }
}
.redButton{
    padding: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px)min(max(25px, calc(1.5625rem + ((1vw - 7.68px) * 2.1701))), 50px);
    width: fit-content;
    background-color: #FF0000;
    border: none;
    color: white;
    z-index: 2;
    border-radius: 5px;
    @media(max-width:768px){
        padding: 10px;
        font-size: 14px;
    }
}
.cert{
    justify-content: flex-end;
    align-items: center;
    gap: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
    text-align: center;
    &__icon{
        width: min(max(45px, calc(2.8125rem + ((1vw - 7.68px) * 3.9063))), 90px);
        height: min(max(45px, calc(2.8125rem + ((1vw - 7.68px) * 3.9063))), 90px);
        border-radius: 24px;
        z-index: 2;
    }
    P{
        font-weight: 700;
        font-size: min(max(20px, calc(1.25rem + ((1vw - 7.68px) * 1.3889))), 36px);;
        z-index: 2;
    }
    @media(max-width:768px){
        gap: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px);
        p{
            font-size: min(max(16px, calc(1rem + ((1vw - 7.68px) * 0.6944))), 24px);
        }
    }
}
.book{
    &__block{
        display: flex;
        justify-content: space-between;
        &__in{
            width: 18%;
            display: flex;
            flex-direction: column;
            gap: 10px;
            align-items: center;
            img{
                width: 100%;
                aspect-ratio: 0.8;
                object-fit: cover;
                border-radius: 5px;
            }
            p{
                color: #0000008A;
            }
        }
    }
}
.contact1{
    &__block{
        display: flex;
        justify-content: space-around;
        padding: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px) 0px;
        margin: auto 0;
        &__in{
            width: 22%;
            img{
                width: 60%;
                aspect-ratio: 1;
                object-fit: cover;
                cursor: pointer;
            }
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;
            gap: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px);
            font-weight: 700;
        }
    }
    @media(max-width:768px){
        &__block{
            padding: 10px 0px;
            flex-wrap: wrap;
            gap: 5%;
            row-gap: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
            &__in{
                width: 47%;
            }
        }
    }
}
.test{
    &__block{
        display: flex;
        justify-content: space-between;
        &__in{
            width: 20%;
            display: flex;
            flex-direction: column;
            gap: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px);
            align-items: center;
            text-align: center;
            &__name{
                font-weight: 700;
            }
            &__bot{
                color: #0000008A;
            }
            img{
                width: 100%;
                aspect-ratio: 1 !important;
                height: auto;
                object-fit: cover;
            }
        }
        @media(max-width:768px){
            flex-wrap: wrap;
            gap: 5%;
            row-gap: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
            &__in{
                width: 30%;
            }
        }
    }
}
.parent {
  position: relative;

  &__backdrop {
    position: absolute;
    z-index: 100;
    inset: 0;
    background-color: rgba(0,0,0, 0.5);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
@media(max-width: 768px){
    .schools{
        &__right{
            &__top{
                &__tabs{
                    ::-webkit-scrollbar{
                        display: none;
                    }
                    overflow: auto!important;
                    scrollbar-width: none; /* Firefox */
                    -ms-overflow-style: none; /* Internet Explorer и Edge */
                }
            }
            &__block{
                &__sale{
                    &__top{
                        &__title{
                            font-size: 20px;
                            font-weight: 600!important;
                        }
                    }
                }

            }
        }
    }
    .customBlock p {
        font-size: 14px!important;
        text-align: center;
    }
    .indiv{
        &__block{
            &__in{
                &__left{
                    &__name{
                        font-size: 14px;
                        text-align: left;
                    }
                }
                button {
                    font-size: 14px;
                    width: fit-content;
                    padding: 5px 10px;
                }
            }
        }
    }
    .online{
        &__block{
            &__in {
                a {
                    width: fit-content;
                    font-size: 14px!important;
                    padding: 5px 10px;
                }
                &__name {
                    font-size: 14px;
                }
            }
        }
    }
}
</style>